import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Grid } from "@mui/material";
import { ClusterHMICard } from "../ClusterHMICard/ClusterHMICard.view";
import { IClusterHMIProps } from "../ClusterHMICard/ClusterHMICardInterfaces";

interface ISortableClusterHMICardProps extends IClusterHMIProps {
    id: string;
}

export const SortableClusterHMICard = ({
    id,
    machineCenter,
    clusterHMINumber,
    index,
}: ISortableClusterHMICardProps) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        gridRow: clusterHMINumber <= 2 ? 1 : index < Math.ceil(clusterHMINumber / 2) ? 1 : 2,
        height: "100%",
    };

    return (
        <Grid
            item
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <ClusterHMICard machineCenter={machineCenter} clusterHMINumber={clusterHMINumber} index={index} />
        </Grid>
    );
};
